import { BaseEntity } from "@app/models/rest/base-entity";
import { Roster } from "@app/models/rest/roster/roster";
import { HateoasResource } from "@lagoshny/ngx-hateoas-client";

@HateoasResource("rosterRunHistory")
export class RosterRunHistory extends BaseEntity {
  runTime: Date;
  roster: Roster;
  generatedShiftCount: number;
}
